/**
 * How a user is named in the UI: `firstName lastName`, falling back to
 * `username` when no real name is on the account. Undefined when nothing is
 * set — callers decide what to show instead.
 *
 * Shared so the server stamps case attribution with exactly the name the client
 * would have rendered.
 */
export function getUserDisplayName({
  username,
  firstName,
  lastName,
}: {
  firstName?: string;
  lastName?: string;
  username?: string;
}): string | undefined {
  const fullName = [firstName, lastName]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(" ");
  return fullName || username?.trim() || undefined;
}
